"use client";

import { useDrawer } from "@/components/drawer";
import { ContactPractitionerForm } from "../components/contact-practitioner-form";

/** Opens the "Contact Me" drawer — the one place that wires the form to a practitioner's username. */
export function useInquiry() {
  const { openDrawer } = useDrawer();

  const contact = (username: string, practitionerName: string) =>
    openDrawer(<ContactPractitionerForm username={username} practitionerName={practitionerName} />, {
      title: "Contact Me",
    });

  return { contact };
}
